import { goNoGoTask } from './goNoGo';
import { speedMatchTask } from './speedMatch';
import { flankerTask } from './flanker';
import { stroopTask } from './stroop';
import { patternComparisonTask } from './patternComparison';
import { digitSymbolTask } from './digitSymbol';
import { mentalRotationTask } from './mentalRotation';
import { paperFoldingTask } from './paperFolding';
import { cuedSwitchTask } from './switchTasks';
import { navonSwitchTask } from './navonSwitch';
import { nBackTask } from './nBack';
import { timedArithmeticTask } from './timedArithmetic';
import { trailMakingTask } from './trailMaking';
import { corsiSpanTask } from './corsiSpan';
import { delayedRecognitionTask } from './delayedRecognition';
import { towerOfLondonTask } from './towerOfLondon';
import { spatialAssemblyTask } from './spatialAssembly';
import { matrixReasoningTask } from './matrixReasoning';

// The eighteen taskIds the server serves. Declared as data rather than derived
// from TASKS so that a missing renderer is a visible hole in this list instead
// of a run that silently renders nothing.
export const ALL_TASK_IDS = Object.freeze([
  'go-no-go', 'speed-match', 'n-back', 'trail-making', 'timed-arithmetic', 'spatial-assembly',
  'flanker', 'stroop', 'pattern-comparison', 'digit-symbol', 'corsi-span', 'delayed-recognition',
  'cued-switch', 'navon-switch', 'matrix-reasoning', 'tower-of-london',
  'mental-rotation', 'paper-folding',
]);

const MODULES = [
  goNoGoTask, speedMatchTask, flankerTask, stroopTask,
  patternComparisonTask, digitSymbolTask, mentalRotationTask, paperFoldingTask,
  cuedSwitchTask, navonSwitchTask,
  nBackTask, timedArithmeticTask, trailMakingTask,
  corsiSpanTask, delayedRecognitionTask, towerOfLondonTask,
  spatialAssemblyTask, matrixReasoningTask,
];

const TASKS = MODULES.reduce((acc, t) => {
  acc[t.id] = t;
  return acc;
}, Object.create(null));

export function taskById(id) {
  return TASKS[id] || null;
}
